import { render, staticRenderFns } from "./P17PrapaSummary.vue?vue&type=template&id=2dfc9142&"
import script from "./P17PrapaSummary.vue?vue&type=script&lang=js&"
export * from "./P17PrapaSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports